import React from "react";

import { Avatar, Card, Typography, makeStyles } from "@material-ui/core";

import { formatCurrency } from "@ds-developer/frontend";
import PortletTitle from "@ds-developer/portlet-title";

import CardSkeleton from "../Skeleton";

import { TodaysIncomeProps } from "./types";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    maxHeight: "96px",
  },
  avatar: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    height: 48,
    width: 48,
  },
}));

const TodaysIncome: React.FC<TodaysIncomeProps> = ({
  loading = false,
  incomeInPennies = 0,
}) => {
  const classes = useStyles();

  return loading ? (
    <CardSkeleton dark />
  ) : (
    <Card className={classes.root}>
      <PortletTitle title="Today's income" contrast>
        <Typography
          variant="subtitle1"
          component="span"
          data-test="homepage-todays-income-amount"
        >
          {formatCurrency(incomeInPennies, true)}
        </Typography>
      </PortletTitle>
      <Avatar className={classes.avatar}>£</Avatar>
    </Card>
  );
};

export default TodaysIncome;
